/* eslint-disable no-empty-pattern */
import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  topPerformingRequest: ['page', 'page_size', 'search', 'filter', 'sort', 'nextPage'],
  topPerformingSuccess: ['list'],
  topPerformingReset: null,

  topPerformingFetchingReset: null,

  topPerformingIdRequest: ['id'],
  topPerformingIdSuccess: ['focusRow'],
  topPerformingIdReset: null,

  setTopPerformingPageColumnSize: ['page_column_size'],

  followAuthorTppRequest: ['authorId'],
  followAuthorTppSuccess: ['authorId', 'followed'],

  saveTopPerformingRequest: ['publicationId', 'folderId'],
  saveTopPerformingSuccess: ['publicationId', 'saved'],
  saveTopPerformingReset: null,

  reportReasonsTppRequest: null,
  reportReasonsTppSuccess: ['reportReasons'],
  reportReasonsTppReset: null,

  sendReportTppRequest: ['id', 'data'],
  sendReportTppSuccess: ['sendReportResult'],
  sendReportTppReset: null,

  reportFetchingTppReset: null,
})

export const TopPerformingTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  followAuthorFetching: false,
  savePublicationFetching: false,

  reportReasons: null,
  reportReasonsFetching: false,

  sendReportResult: null,
  sendReportFetching: false,

  page: 1,
  page_size: 12,
  page_column_size: 3,

  focusRow: null,
})

/* ------------- Selectors ------------- */
export const TopPerformingSelectors = {
  getState: state => state.topPerforming,
}

/* ------------- Reducers ------------- */

export const topPerformingRequest = (state, {page, page_size, search, filter, sort, nextPage}) => {
  const newState = {
    fetching: true,
  }
  page && (newState.page = page)
  page_size && (newState.page_size = page_size)
  return state.merge(newState)
}
export const topPerformingSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}
export const topPerformingReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    followAuthorFetching: false,

    saveTopPerformingResult: null,
    savePublicationFetching: false,

    reportReasons: null,
    reportReasonsFetching: false,

    sendReportResult: null,
    sendReportFetching: false,

    page: 1,
    page_size: 12,

    focusRow: null,
  })
}

export const topPerformingIdRequest = (state, {id}) => {
  return state.merge({fetching: true})
}
export const topPerformingIdSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}
export const topPerformingIdReset = state => {
  return state.merge({focusRow: null})
}

export const topPerformingFetchingReset = state => {
  return state.merge({
    fetching: false,
    followAuthorFetching: false,
    savePublicationFetching: false,
  })
}

export const followAuthorTppRequest = (state, {authorId}) => {
  return state.merge({followAuthorFetching: true})
}

export const followAuthorTppSuccess = (state, {authorId, followed}) => {
  const newResults = state.list?.results?.map(post => {
    if (post?.publication?.author.id === authorId) {
      return {
        ...post,
        publication: {...post.publication, author: {...post.publication.author, is_following: followed}},
      }
    } else {
      return {...post}
    }
  })
  const newList = state.list ? {...state.list, results: [...newResults]} : null
  let newFocusRow = null
  if (state.focusRow) {
    if (state.focusRow.publication.author.id === authorId) {
      newFocusRow = {
        ...state.focusRow,
        publication: {...state.focusRow.publication, author: {...state.focusRow.publication.author, is_following: followed}},
      }
    }
  }
  return state.merge({
    list: {...newList},
    focusRow: newFocusRow,
  })
}

export const saveTopPerformingRequest = (state, {publicationId, folderId}) => {
  return state.merge({savePublicationFetching: true})
}

export const saveTopPerformingSuccess = (state, {publicationId, saved}) => {
  const newResults = state.list?.results.map(post => {
    if (post.publication.id === publicationId) {
      return {...post, publication: {...post.publication, is_saved: saved}}
    } else {
      return {...post}
    }
  })
  const newList = {...state.list, results: [...newResults]}
  let newFocusRow = state.focusRow ? {...state.focusRow} : null
  if (state.focusRow) {
    if (state.focusRow.publication.id === publicationId) {
      newFocusRow = {
        ...state.focusRow,
        publication: {...state.focusRow.publication, is_saved: saved},
      }
    }
  }
  return state.merge({
    list: {...newList},
    focusRow: newFocusRow,
    saveTopPerformingResult: {id: publicationId, saved: saved},
  })
}

export const saveTopPerformingReset = state => {
  return state.merge({saveTopPerformingResult: null})
}

export const setTopPerformingPageColumnSize = (state, {page_column_size}) => {
  return state.merge({page_column_size})
}

export const reportReasonsTppRequest = (state, {}) => {
  return state.merge({reportReasonsFetching: true})
}
export const reportReasonsTppSuccess = (state, {reportReasons}) => {
  return state.merge({reportReasonsFetching: false, reportReasons})
}
export const reportReasonsTppReset = state => {
  return state.merge({reportReasonsFetching: false, reportReasons: null})
}

export const sendReportTppRequest = (state, {id, data}) => {
  return state.merge({sendReportFetching: true})
}
export const sendReportTppSuccess = (state, {sendReportResult}) => {
  return state.merge({sendReportFetching: false, sendReportResult})
}
export const sendReportTppReset = state => {
  return state.merge({sendReportFetching: false, sendReportResult: null})
}

export const reportFetchingTppReset = state => {
  return state.merge({
    reportReasonsFetching: false,
    sendReportFetching: false,
  })
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  //MAIN
  [Types.TOP_PERFORMING_REQUEST]: topPerformingRequest,
  [Types.TOP_PERFORMING_SUCCESS]: topPerformingSuccess,
  [Types.TOP_PERFORMING_RESET]: topPerformingReset,

  [Types.TOP_PERFORMING_ID_REQUEST]: topPerformingIdRequest,
  [Types.TOP_PERFORMING_ID_SUCCESS]: topPerformingIdSuccess,
  [Types.TOP_PERFORMING_ID_RESET]: topPerformingIdReset,

  [Types.TOP_PERFORMING_FETCHING_RESET]: topPerformingFetchingReset,

  //Can replaced

  [Types.FOLLOW_AUTHOR_TPP_REQUEST]: followAuthorTppRequest,
  [Types.FOLLOW_AUTHOR_TPP_SUCCESS]: followAuthorTppSuccess,

  [Types.SAVE_TOP_PERFORMING_REQUEST]: saveTopPerformingRequest,
  [Types.SAVE_TOP_PERFORMING_SUCCESS]: saveTopPerformingSuccess,
  [Types.SAVE_TOP_PERFORMING_RESET]: saveTopPerformingReset,

  [Types.SET_TOP_PERFORMING_PAGE_COLUMN_SIZE]: setTopPerformingPageColumnSize,

  [Types.REPORT_REASONS_TPP_REQUEST]: reportReasonsTppRequest,
  [Types.REPORT_REASONS_TPP_SUCCESS]: reportReasonsTppSuccess,
  [Types.REPORT_REASONS_TPP_RESET]: reportReasonsTppReset,
  [Types.REPORT_FETCHING_TPP_RESET]: reportFetchingTppReset,

  [Types.SEND_REPORT_TPP_REQUEST]: sendReportTppRequest,
  [Types.SEND_REPORT_TPP_SUCCESS]: sendReportTppSuccess,
  [Types.SEND_REPORT_TPP_RESET]: sendReportTppReset,
})
